import { ElLoading, type LoadingOptionsResolved } from 'element-plus';

let loadingInstance: ReturnType<typeof ElLoading.service> | null = null;

export const showLoading = (options?: Partial<LoadingOptionsResolved>) => {
  if (loadingInstance) {
    hideLoading();
  }

  const defaultOptions: Partial<LoadingOptionsResolved> = {
    lock: true,
    text: '加载中...',
    background: 'rgba(255, 255, 255, 0.5)',
    ...options
  };

  loadingInstance = ElLoading.service(defaultOptions);

  return loadingInstance;
};

export const setLoadingText = (text: string) => {
  loadingInstance?.setText(text);
};

export const hideLoading = () => {
  if (loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }
};
